var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import { updatePermissions } from "./switchboard";
import { ENABLE, DISABLE } from "../constants/products";
import permissionsForTenantQuery from "./queries/PermissionsForTenant";
var ProductsService = /** @class */ (function () {
    function ProductsService() {
        this.get = function (tenant, options) {
            if (options === void 0) { options = {}; }
            var variables = { tenantId: tenant.uuid };
            return client.query(__assign(__assign({}, options), { query: permissionsForTenantQuery, variables: variables })).then(function (_a) {
                var data = _a.data;
                return data;
            });
        };
        this.enable = function (tenant, product, team) {
            var data = {
                tenantId: tenant.uuid,
                action: ENABLE[product],
                teamId: team ? team.uuid : null,
                values: []
            };
            return updatePermissions(data);
        };
        this.disable = function (tenant, product, team) {
            var data = {
                tenantId: tenant.uuid,
                action: DISABLE[product],
                teamId: team ? team.uuid : null,
                values: []
            };
            return updatePermissions(data);
        };
    }
    return ProductsService;
}());
var service = new ProductsService();
export default service;
